// extracted by mini-css-extract-plugin
export default {"featuredArticleCard":"FeaturedArticleCard_featuredArticleCard__ehQSf"};